const getSortedPackageTypes = (masterPackageType, packageTypes)=>{
    // Put the master package type first,
    // this will guarantee the default selected
    const newPackageTypes = [
        masterPackageType,
        ...packageTypes
    ];
    // remove duplicates
    return newPackageTypes.reduce((prev, curr)=>{
        const duplicate = prev.some((packageType)=>packageType.packageQuantity === curr.packageQuantity
        );
        if (!duplicate) {
            prev.push(curr);
        }
        return prev;
    }, []);
};

export { getSortedPackageTypes };
//# sourceMappingURL=get-sorted-package-types.js.map
